module.exports = __webpack_public_path__ + "static/media/TUNE_6620.fabc70b6.jpg";